import { createFileRoute } from '@tanstack/react-router'

import { SETUP_STEPS, WizardStep } from '@/components/onboarding'
import { TextField } from '@/components/shared'
import { LINKS } from '@/mocks/onboarding/odkazy'

export const Route = createFileRoute('/onboarding/odkazy')({
  head: () => ({ meta: [{ title: 'Odkazy na vás · Aplikace Bitez' }] }),
  component: OnboardingOdkazy,
})

/**
 * Where a post can send people. Three fields, all optional, and they are in the
 * second run for a small but real reason: **a URL is not remembered, it is
 * copied** — from a browser, on a computer, usually after looking it up.
 *
 * Each one says what it buys rather than what it is: "web" on its own does not
 * explain why an app is asking.
 */
function OnboardingOdkazy() {
  return (
    <WizardStep
      step={3}
      steps={SETUP_STEPS}
      backHref="/onboarding/napojeni"
      nextHref="/onboarding/listky"
      note="Dáváme je do profilu a do příspěvků, kde dávají smysl — třeba rezervaci pod focení večeře."
      skip={{ label: 'Přeskočit', href: '/onboarding/listky' }}
    >
      <div className="space-y-5">
        {LINKS.map((link) => (
          <TextField
            key={link.label}
            label={link.label}
            placeholder={link.placeholder}
            defaultValue={link.value}
          />
        ))}
      </div>
    </WizardStep>
  )
}
